import React from "react";

import ReqActionBar from "../common/ReqActionBar";
import ObaDetail from "./manual/ReadOnlyDetailForm";
import ObaForm from "./survey/ObaForm";
import StatusComp from "../../common/StatusComp";

const ObaDetailComp = (props)=>{
    const isTemplatedForm = () => {
        return props.data.templateStr && props.data.templateStr !== "";
    }

    let detailForm;
    if (isTemplatedForm()) {
        detailForm = <ObaForm 
                        editorItem = { { id: props.data.id, formData: props.data.formData, 
                            template: {templateStr:props.data.templateStr} } }
                        data = { props.data } 
                        isReadOnly={ true }
                    />;
    } else {
        detailForm = <ObaDetail data={props.data} mode="DETAIL"/>;
    }
    return(
        <div className="panel">
            <div className="panel-header">
                <div className="panel-header-label">Outside Business Activity Request Details</div>
                <div className="ml-4 mr-4">Approval Status : <StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                {props.data.createdTimeStampUserTz && <div>Created : {props.data.createdTimeStampUserTz}</div>}
                {props.data.lastAction !== "Pending" && <div className="ml-4">{props.data.lastAction} : {props.data.updatedTimeStampUserTz}</div>}
            </div>
            {detailForm}
            <ReqActionBar
                reqId={props.data.id}
                reqType="OBA"
                reqStatus={props.data.status}
                reloadItem={props.reloadItem}
                handleUpdate={props.handleUpdate}
                handleClose={props.handleClose}
                formState="VIEW"
                handleformStateChange = {props.handleFormStateChange}
            />
            

        </div>
    );
};


export default ObaDetailComp;